var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-home-shapes"},[_c('icon',{staticClass:"x-shape-right",attrs:{"icon":"ShapeRight"}}),_c('icon',{staticClass:"x-shape-left",attrs:{"icon":"ShapeLeft"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }